export const ADD_REQUEST = 'ADD_REQUEST'
export const HANDLE_REQUEST_RESULTS = 'HANDLE_REQUEST_RESULTS'
export const REMOVE_REQUEST = 'REMOVE_REQUEST'
export const REMOVE_MANY_REQUESTS = 'REMOVE_MANY_REQUESTS'

export const GEOGRAPHY_HOUSING_TYPE_ALL = 'GEOGRAPHY_HOUSING_TYPE_ALL'
